/**
 * The noVNC client, loaded on first use so its ~280 kB stays out of the main
 * bundle. Tests mock this module.
 *
 * Why @novnc/novnc 1.5.0, by deep path:
 *  - 1.6.0+ use a top-level `await` (WebCodecs H.264 probe in
 *    core/util/browser.js; 1.6.0's CommonJS build keeps it too). Parcel 2
 *    wraps modules of async bundles in functions, where `await` is a syntax
 *    error: `parcel build` fails in @parcel/optimizer-swc ("await isn't
 *    allowed in non-async function"). 1.5.0's `lib/` is plain CommonJS.
 *  - The package has no `main`, only `exports`, and Parcel's resolver
 *    ignores `exports` unless `packageExports` is turned on app-wide, so the
 *    bare specifier doesn't resolve.
 * Xvnc's encodings (Tight/ZRLE) don't need the newer H.264 decoder.
 */
import type RFB from "@novnc/novnc/lib/rfb";

export type RfbClient = RFB;
export type RfbConstructor = typeof RFB;

let pending: Promise<RfbConstructor> | null = null;

export const loadRfb = (): Promise<RfbConstructor> => {
  if (!pending) {
    pending = import("@novnc/novnc/lib/rfb")
      .then((mod) => mod.default)
      .catch((error) => {
        pending = null;
        throw error;
      });
  }
  return pending;
};

/** Subprotocols carrying the single-use token (design §7 step 6). */
export const rfbProtocols = (token: string): string[] => ["rs.v1", token];
